import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import { Chart as Chart2, registerables } from "chart.js";
import {
  ChoroplethController,
  GeoFeature,
  ColorScale,
  ProjectionScale,
} from "chartjs-chart-geo";
import * as ChartGeo from "chartjs-chart-geo";
import {
  getOrderByCustomerTypeSummary,
  getSalesDashboard,
  getSalesOrderSummary,
  getSalesTargetSummary,
  getTopCustomersSummary,
  getTopSalesItemsSummary,
  getTopSalesmansSummary,
  getWonLostSummary,
} from "../../../../services/sales/salesReportService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import SearchFiscalPeriod from "../../setup/finance/searchFiscalPeriod";
import { DialogActions, IconButton, Typography } from "@material-ui/core";
import { Search } from "@mui/icons-material";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { abbrMonthName, abbrNum, formatPercent } from "../../../../utils/utils";
import { DateTime } from "luxon";
import _ from "lodash";

// register controller in chart.js and ensure the defaults are set
Chart2.register(ChoroplethController, GeoFeature, ColorScale, ProjectionScale);
Chart2.register(...registerables);

function SalesDashboard(props) {
  const {
    companyProfile,
    currentFiscalYear,
    currentFiscalPeriod,
    reload,
  } = useGlobalData();
  const [
    openSearchFiscalYearSalesOrder,
    setOpenSearchFiscalYearSalesOrder,
  ] = useState(false);
  const [
    openSearchFiscalYearSalesTarget,
    setOpenSearchFiscalYearSalesTarget,
  ] = useState(false);
  const [
    openSearchFiscalYearWonLost,
    setOpenSearchFiscalYearWonLost,
  ] = useState(false);
  const [
    openSearchFiscalYearOrderByCustomerType,
    setOpenSearchFiscalYearOrderByCustomerType,
  ] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [
    openSearchFiscalPeriodTopCustomers,
    setOpenSearchFiscalPeriodTopCustomers,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopSalesItems,
    setOpenSearchFiscalPeriodTopSalesItems,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopSalesmans,
    setOpenSearchFiscalPeriodTopSalesmans,
  ] = useState(false);
  const [openSearchFiscalPeriod, setOpenSearchFiscalPeriod] = useState(false);
  const [fiscalYearSalesOrder, setFiscalYearSalesOrder] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearSalesTarget, setFiscalYearSalesTarget] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearWonLost, setFiscalYearWonLost] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [
    fiscalYearOrderByCustomerType,
    setFiscalYearOrderByCustomerType,
  ] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalPeriodTopCustomers, setFiscalPeriodTopCustomers] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [fiscalPeriodTopSalesItems, setFiscalPeriodTopSalesItems] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [fiscalPeriodTopSalesmans, setFiscalPeriodTopSalesmans] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [totalSales, setTotalSales] = useState(0);
  const [totalSalesPercent, setTotalSalesPercent] = useState(0);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [totalCustomersPercent, setTotalCustomersPercent] = useState(0);
  const [totalDealsWon, setTotalDealsWon] = useState(0);
  const [totalDealsWonPercent, setTotalDealsWonPercent] = useState(0);
  const [totalSalesTargetAchieved, setTotalSalesTargetAchieved] = useState(0);
  const [
    totalSalesTargetAchievedPercent,
    setTotalSalesTargetAchievedPercent,
  ] = useState(0);

  const [salesOrderSummaryAmount, setSalesOrderSummaryAmount] = useState({
    totalSales: 0,
    totalOrders: 0,
  });
  const [salesOrderSummaryData, setSalesOrderSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Sales",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Orders",
        borderColor: "#0096ec",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const salesOrderSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [salesTargetSummaryAmount, setSalesTargetSummaryAmount] = useState({
    totalSalesActual: 0,
    totalSalesTarget: 0,
  });
  const [salesTargetSummaryData, setSalesTargetSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "bar",
        label: "Sales Actual",
        backgroundColor: "#12b18c",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Sales Target",
        backgroundColor: "#6610f2",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
    ],
  });

  const salesTargetSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [topCustomersSummaryData, setTopCustomersSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topCustomersSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topCustomersSummaryPlugins = {
    id: "topCustomersSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topCustomersSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [topSalesItemsSummaryData, setTopSalesItemsSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topSalesItemsSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topSalesItemsSummaryPlugins = {
    id: "topSalesItemsSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topSalesItemsSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [topSalesmansSummaryData, setTopSalesmansSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topSalesmansSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topSalesmansSummaryPlugins = {
    id: "topSalesmansSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topSalesmansSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [wonLostSummaryData, setWonLostSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Won Deals",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Lost Deals",
        borderColor: "#f1416c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const wonLostSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [
    orderByCustomerTypeSummaryData,
    setOrderByCustomerTypeSummaryData,
  ] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "New Customer Order",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Old Customer Order",
        borderColor: "#6610f2",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const orderByCustomerTypeSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  async function salesByCountriesSummaryData(salesByCountries = []) {
    let canvas = document.getElementById("canvasSalesByCountries");
    if (!canvas) return;

    fetch("https://unpkg.com/world-atlas@2.0.2/countries-50m.json")
      .then((result) => result.json())
      .then((datapoint) => {
        const countries = ChartGeo.topojson.feature(
          datapoint,
          datapoint.objects.countries
        ).features;

        if (chart) {
          chart.destroy();
        }

        let countryData = [];
        countries.map((country) => {
          const countryValue = _.find(salesByCountries, [
            "countryName",
            country.properties.name,
          ]);

          if (countryValue && countryValue.salesAmount > 0) {
            countryData.push({
              feature: country,
              value: countryValue.salesAmount,
            });
          } else {
            countryData.push({
              feature: country,
              value: 0,
            });
          }
        });

        const chart = new Chart2(canvas.getContext("2d"), {
          type: "choropleth",
          data: {
            labels: countries.map((country) => country.properties.name),
            datasets: [
              {
                label: "Countries",
                //outline: nation,
                data: countryData,
              },
            ],
          },
          options: {
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                callbacks: {
                  label: function(tooltipItem, data, value) {
                    return `${
                      tooltipItem.dataset.data[tooltipItem.dataIndex].feature
                        .properties.name
                    }: ${companyProfile.currency.currencyCode} ${
                      tooltipItem.formattedValue
                    }`;
                  },
                },
                usePointStyle: true,
              },
            },
            scales: {
              xy: { projection: "equalEarth" },
              color: {
                axis: "x",
                quantize: 5,
                ticks: {
                  color: "#6c7293",
                  callback: (value, index, values) => {
                    return abbrNum(value, 2);
                  },
                },
                legend: {
                  position: "bottom-left",
                },
              },
            },
          },
        });

        return () => {
          chart.destroy();
        };
      });
  }

  async function getSalesDashboardData(fiscalYearID = 0, fiscalPeriodID = 0) {
    const response = await getSalesDashboard(fiscalYearID, fiscalPeriodID);
    const { data } = response.data;
    const {
      salesHeader,
      customersHeader,
      dealsWonHeader,
      salesTargetAchievedHeader,
      salesOrderSummary,
      salesTargetSummary,
      topCustomersSummary,
      topSalesItemsSummary,
      topSalesmansSummary,
      wonLostSummary,
      orderByCustomerTypeSummary,
      salesByCountriesSummary,
    } = data;
    setTotalSales(salesHeader.totalSales);
    setTotalSalesPercent(salesHeader.totalSalesPercent);
    setTotalCustomers(customersHeader.totalCustomers);
    setTotalCustomersPercent(customersHeader.totalCustomersPercent);
    setTotalDealsWon(dealsWonHeader.totalDealsWon);
    setTotalDealsWonPercent(dealsWonHeader.totalDealsWonPercent);
    setTotalSalesTargetAchieved(
      salesTargetAchievedHeader.totalSalesTargetAchieved
    );
    setTotalSalesTargetAchievedPercent(
      salesTargetAchievedHeader.totalSalesTargetAchievedPercent
    );
    setSalesOrderSummaryData(salesOrderSummary.datasets);
    setSalesOrderSummaryAmount({
      totalSales: salesOrderSummary.totalSales,
      totalOrders: salesOrderSummary.totalOrders,
    });
    setSalesTargetSummaryData(salesTargetSummary.datasets);
    setSalesTargetSummaryAmount({
      totalSalesActual: salesTargetSummary.totalSalesActual,
      totalSalesTarget: salesTargetSummary.totalSalesTarget,
    });
    setTopCustomersSummaryData(topCustomersSummary.datasets);
    setTopSalesItemsSummaryData(topSalesItemsSummary.datasets);
    setTopSalesmansSummaryData(topSalesmansSummary.datasets);
    setWonLostSummaryData(wonLostSummary.datasets);
    setOrderByCustomerTypeSummaryData(orderByCustomerTypeSummary.datasets);
    salesByCountriesSummaryData(salesByCountriesSummary.datasets);
  }

  async function getSalesOrderSummaryData(fiscalYearID = 0) {
    const response = await getSalesOrderSummary(fiscalYearID);
    const { data } = response.data;
    setSalesOrderSummaryData(data.salesOrderSummary);
    setSalesOrderSummaryAmount({
      totalSales: data.totalSales,
      totalOrders: data.totalOrders,
    });
  }

  async function getSalesTargetSummaryData(fiscalYearID = 0) {
    const response = await getSalesTargetSummary(fiscalYearID);
    const { data } = response.data;
    setSalesTargetSummaryData(data.salesTargetSummary);
    setSalesTargetSummaryAmount({
      totalSalesActual: data.totalSalesActual,
      totalSalesTarget: data.totalSalesTarget,
    });
  }

  async function getTopCustomersSummaryData(fiscalPeriodID = 0) {
    const response = await getTopCustomersSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopCustomersSummaryData(data.topCustomersSummary);
  }

  async function getTopSalesItemsSummaryData(fiscalPeriodID = 0) {
    const response = await getTopSalesItemsSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopSalesItemsSummaryData(data.topSalesItemsSummary);
  }

  async function getTopSalesmansSummaryData(fiscalPeriodID = 0) {
    const response = await getTopSalesmansSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopSalesmansSummaryData(data.topSalesmansSummary);
  }

  async function getWonLostSummaryData(fiscalYearID = 0) {
    const response = await getWonLostSummary(fiscalYearID);
    const { data } = response.data;
    setWonLostSummaryData(data.wonLostSummary);
  }

  async function getOrderByCustomerTypeSummaryData(fiscalYearID = 0) {
    const response = await getOrderByCustomerTypeSummary(fiscalYearID);
    const { data } = response.data;
    setOrderByCustomerTypeSummaryData(data.orderByCustomerTypeSummary);
  }

  useEffect(() => {
    getSalesDashboardData(currentFiscalYear.ID, currentFiscalPeriod.ID);
  }, [reload]);
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-tags" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Sales
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalSales, 2)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalSalesPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalSalesPercent, 2, true)}
                      </Typography>
                    ) : totalSalesPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalSalesPercent, 2, true)}
                      </Typography>
                    ) : totalSalesPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalSalesPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-user-tag" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Customers
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalCustomers, 0)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalCustomersPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalCustomersPercent, 2, true)}
                      </Typography>
                    ) : totalCustomersPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalCustomersPercent, 2, true)}
                      </Typography>
                    ) : totalCustomersPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalCustomersPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-hands-helping" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Deals Won
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalDealsWon, 2)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalDealsWonPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalDealsWonPercent, 2, true)}
                      </Typography>
                    ) : totalDealsWonPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalDealsWonPercent, 2, true)}
                      </Typography>
                    ) : totalDealsWonPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalDealsWonPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-crosshairs" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Sales Achieved
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {formatPercent(totalSalesTargetAchieved, 2)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalSalesTargetAchievedPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(
                          totalSalesTargetAchievedPercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : totalSalesTargetAchievedPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(
                          totalSalesTargetAchievedPercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : totalSalesTargetAchievedPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(
                          totalSalesTargetAchievedPercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Sales Order Overview
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalYearSalesOrder.startMonthName) +
                            " " +
                            fiscalYearSalesOrder.year +
                            " - " +
                            abbrMonthName(fiscalYearSalesOrder.endMonthName) +
                            " " +
                            fiscalYearSalesOrder.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearSalesOrder(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-9 col-lg-9">
                <Chart
                  type="bar"
                  data={salesOrderSummaryData}
                  options={salesOrderSummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3 p-0">
                <div className="column mt-md-5">
                  <div className="col-sm-12 col-md-12 col-lg-12 pl-md-0">
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Sales
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(salesOrderSummaryAmount.totalSales, 2)}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Orders
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(salesOrderSummaryAmount.totalOrders, 2)}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Sales Target vs Actual
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalYearSalesTarget.startMonthName) +
                            " " +
                            fiscalYearSalesTarget.year +
                            " - " +
                            abbrMonthName(fiscalYearSalesTarget.endMonthName) +
                            " " +
                            fiscalYearSalesTarget.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearSalesTarget(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-9 col-lg-9">
                <Chart
                  type="bar"
                  data={salesTargetSummaryData}
                  options={salesTargetSummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3 p-0">
                <div className="column mt-md-5">
                  <div className="col-sm-12 col-md-12 col-lg-12 pl-md-0">
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Sales Actual
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(
                            salesTargetSummaryAmount.totalSalesActual,
                            2
                          )}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Sales Target
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(
                            salesTargetSummaryAmount.totalSalesTarget,
                            2
                          )}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Customers
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalPeriodTopCustomers.monthName) +
                            " " +
                            fiscalPeriodTopCustomers.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopCustomers(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topCustomersSummaryData}
                  options={topCustomersSummaryOptions}
                  plugins={[topCustomersSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Sales Items
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalPeriodTopSalesItems.monthName) +
                            " " +
                            fiscalPeriodTopSalesItems.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopSalesItems(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topSalesItemsSummaryData}
                  options={topSalesItemsSummaryOptions}
                  plugins={[topSalesItemsSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Salesman
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalPeriodTopSalesmans.monthName) +
                            " " +
                            fiscalPeriodTopSalesmans.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopSalesmans(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topSalesmansSummaryData}
                  options={topSalesmansSummaryOptions}
                  plugins={[topSalesmansSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Quotation Won vs Lost
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalYearWonLost.startMonthName) +
                            " " +
                            fiscalYearWonLost.year +
                            " - " +
                            abbrMonthName(fiscalYearWonLost.endMonthName) +
                            " " +
                            fiscalYearWonLost.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearWonLost(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={wonLostSummaryData}
                  options={wonLostSummaryOptions}
                  style={{ minHeight: "180px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Orders By Customer Type
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalYearOrderByCustomerType.startMonthName
                          ) +
                            " " +
                            fiscalYearOrderByCustomerType.year +
                            " - " +
                            abbrMonthName(
                              fiscalYearOrderByCustomerType.endMonthName
                            ) +
                            " " +
                            fiscalYearOrderByCustomerType.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearOrderByCustomerType(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={orderByCustomerTypeSummaryData}
                  options={orderByCustomerTypeSummaryOptions}
                  style={{ minHeight: "180px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Sales By Countries
                </Typography>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <canvas id="canvasSalesByCountries"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            if (openSearchFiscalYearSalesOrder) {
              setFiscalYearSalesOrder({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearSalesOrder(false);
              getSalesOrderSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearSalesTarget) {
              setFiscalYearSalesTarget({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearSalesTarget(false);
              getSalesTargetSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearWonLost) {
              setFiscalYearWonLost({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearWonLost(false);
              getWonLostSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearOrderByCustomerType) {
              setFiscalYearOrderByCustomerType({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearOrderByCustomerType(false);
              getOrderByCustomerTypeSummaryData(fiscalYear.ID);
            }
            getSalesDashboardData(fiscalYear.ID);
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchFiscalPeriod}
        title="Search Fiscal Period"
        onCloseDialog={() => {
          setOpenSearchFiscalPeriod(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalPeriod
          onSelectFiscalPeriod={(fiscalPeriod) => {
            if (openSearchFiscalPeriodTopCustomers) {
              setFiscalPeriodTopCustomers({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopCustomers(false);
              getTopCustomersSummaryData(fiscalPeriod.ID);
            } else if (openSearchFiscalPeriodTopSalesItems) {
              setFiscalPeriodTopSalesItems({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopSalesItems(false);
              getTopSalesItemsSummaryData(fiscalPeriod.ID);
            } else if (openSearchFiscalPeriodTopSalesmans) {
              setFiscalPeriodTopSalesmans({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopSalesmans(false);
              getTopSalesmansSummaryData(fiscalPeriod.ID);
            }
            setOpenSearchFiscalPeriod(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalPeriod(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default SalesDashboard;
